import React, { FC } from 'react';
import { t } from 'i18next';
import UserShortCut from 'components/common/UserShortCut';
import {
  HistoryItem,
  NoteDetailResponse,
  NoteStatus,
} from 'features/expenses/types/type';
import moment from 'moment';

interface TimelineProps {
  model: NoteDetailResponse;
  history: HistoryItem[];
  statusMap: Record<string, { label: string; className: string }>;
}

const Timeline: FC<TimelineProps> = ({ model, history, statusMap }) => {
  return (
    <div className="minthr-timeline minthr-timeline-collapse minthr-overflow-auto open">
      <>
        <div className="minthr-mb-2">
          {model.status != NoteStatus.Draft &&
            model.status != NoteStatus.Canceled && (
              <>
                {model.userslistApproval
                  .filter((x) => x.actionType == 'Success')
                  .map((approval) => (
                    <div key={approval.userId} className="minthr-timeline">
                      <div className="minthr-timeline-item minthr-pb-2">
                        <div className="minthr-p-2 minthr-border-rounded minthr-border minthr-border-secondary">
                          <div className="minthr-flex minthr-flex-space-between">
                            <UserShortCut
                              src={`upload/profileimages/${approval.userId}/${approval.picturePath}`}
                              alt={`${approval.fullName} avatar`}
                              className="minthr-avatar minthr-avatar-s"
                            />
                            <div className="minthr-ml-2 minthr-w-40 minthr-mr-auto">
                              <div className="h5 minthr-text-truncate minthr-mb-1 text-m">
                                {approval.fullName}
                              </div>
                              <p className="minthr-mb-0 minthr-text-truncate text-m minthr-color-gray">
                                {' '}
                                {approval.departement}{' '}
                              </p>
                            </div>
                            <div className="minthr-w-40 minthr-text-align-right">
                              <span className="minthr-icon-text">
                                {approval.status == 'Approved' && (
                                  <>
                                    <img
                                      className="minthr-icon-xs minthr-ml-auto"
                                      src="/icons/calendar.svg"
                                      alt=""
                                    />
                                    {moment(approval.actionDate).format(
                                      'DD MMM YYYY h:mm',
                                    )}
                                  </>
                                )}
                              </span>

                              <div
                                className={`minthr-badge ${approval.status == 'Pending' ? 'minthr-badge-warning' : 'minthr-badge-success'} minthr-badge-s`}
                              >
                                {t(approval.status)}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </>
            )}

          {model.userslistApproval
            .filter((x) => x.actionType == 'Refund')
            .map((approval) => (
              <div key={approval.userId} className="minthr-timeline">
                <div className="minthr-timeline-item minthr-pb-2">
                  <div className=" minthr-p-2 minthr-border-rounded minthr-border minthr-border-secondary">
                    <div className="minthr-flex minthr-flex-space-between">
                      <UserShortCut
                        src={`upload/profileimages/${approval.userId}/${approval.picturePath}`}
                        alt={`${approval.fullName} avatar`}
                        className="minthr-avatar minthr-avatar-s"
                      />
                      <div className="minthr-ml-2 minthr-w-40 minthr-mr-auto">
                        <div className="h5 minthr-text-truncate minthr-mb-1 text-m">
                          {approval.fullName}
                        </div>
                        <p className="minthr-mb-0 minthr-text-truncate text-m minthr-color-gray">
                          {' '}
                          {approval.departement}{' '}
                        </p>
                      </div>
                      <div className="minthr-w-40 minthr-text-align-right  ">
                        <span className="minthr-icon-text">
                          {approval.status == 'Approved' && (
                            <>
                              <img
                                className="minthr-icon-xs minthr-ml-auto"
                                src="/icons/calendar.svg"
                                alt=""
                              />
                              {moment(approval.actionDate).format(
                                'DD MMM YYYY h:mm',
                              )}
                            </>
                          )}
                        </span>

                        <div
                          className={`minthr-badge ${approval.status == 'Pending' ? 'minthr-badge-warning' : 'minthr-badge-info'} minthr-badge-s`}
                        >
                          {approval.status == 'Pending'
                            ? t(approval.status)
                            : t('Note.Remborse')}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>

        {history.map((h, index) => (
          <div key={index} className="minthr-timeline-item">
            <div className="minthr-timeline-date-icon minthr-icon-bg minthr-icon-bg-xxs minthr-icon-circle minthr-bg-light-gray minthr-ml-1">
              <img
                className="minthr-icon-xs minthr-opacity-0"
                src="/icons/history.svg"
                alt="history icon"
              />
            </div>
            <div className="minthr-timeline-content minthr-px-3 minthr-py-2 minthr-bg-light-gray minthr-icon-rounded">
              <div className="minthr-flex minthr-flex-items-center minthr-flex-space-between">
                <div style={{ width: '60%' }}>
                  <div className="h5 minthr-text-truncate">
                    {t(statusMap[h.action]?.label)}
                  </div>
                  <span className="minthr-icon-text">
                    <img
                      className="minthr-icon-xs"
                      src="/icons/calendar.svg"
                      alt="calendar icon"
                    />
                    {moment(h.actionDate).format('DD MMM YYYY h:mm a')}
                  </span>
                </div>
                {h.userImage && (
                  <UserShortCut
                    src={`upload/profileimages/${h.userImage.id}/${h.userImage.picturePath}`}
                    alt={`${h.userImage.fullName} avatar`}
                    className="minthr-avatar minthr-avatar-m minthr-ml-auto"
                  />
                )}
              </div>
            </div>
          </div>
        ))}
      </>
    </div>
  );
};

export default Timeline;
